/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const actionableObservationEnumsTypeOfUnsafeBehaviourOptionEnum = {
    RiskAwareness: 'RiskAwareness',
    PersonalProtectiveEquipmentPPE: 'PersonalProtectiveEquipmentPPE',
    Ergonomics: 'Ergonomics',
    UnethicalBehavior: 'UnethicalBehavior',
    WorkingAtHeights: 'WorkingAtHeights',
    ElectricHazards: 'ElectricHazards',
    LiftingTechniquesTools: 'LiftingTechniquesTools',
    HousekeepingWorkAreasWalkwaysEmergencyExits: 'HousekeepingWorkAreasWalkwaysEmergencyExits',
    ChemicalHandlingRightStorageHandling: 'ChemicalHandlingRightStorageHandling',
    UnsafeBehaviorNotFollowingHSERequirements: 'UnsafeBehaviorNotFollowingHSERequirements',
    ToolsNotInProperConditionWrongToolsForTheWork: 'ToolsNotInProperConditionWrongToolsForTheWork',
    Other: 'Other',
} as const;

export type ActionableObservationEnumsTypeOfUnsafeBehaviourOptionEnumKey =
    (typeof actionableObservationEnumsTypeOfUnsafeBehaviourOptionEnum)[keyof typeof actionableObservationEnumsTypeOfUnsafeBehaviourOptionEnum];

export type ActionableObservationEnumsTypeOfUnsafeBehaviourOption =
    ActionableObservationEnumsTypeOfUnsafeBehaviourOptionEnumKey;
